import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { guestClientEntry } from '@/clientEntry';

export default function ClientAccessGate({ children, loading = null }) {
  const { status, user, clientExit } = useAuth();
  const location = useLocation();
  if (status === 'loading') return loading;
  if (status === 'guest') return <Navigate to={clientExit || guestClientEntry(location.search)} replace />;
  if (user?.role !== 'client') return <Navigate to="/app" replace />;
  return children;
}
